import { render } from "./CalendarsView.vue?vue&type=template&id=3863ff97&scoped=true"
import script from "./CalendarsView.vue?vue&type=script&lang=js"
export * from "./CalendarsView.vue?vue&type=script&lang=js"

import "./CalendarsView.vue?vue&type=style&index=0&id=3863ff97&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3863ff97"]])

export default __exports__